import React from "react";

function Footer() {
  return (
    <div className = "main-footer">
      <p>[ © 2025 Skills Project Tracker ]&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[ v1.1 ]&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[ ® All rights reserved ]</p>
    </div>
  );
}

export default Footer;          